import Grade from './store'

export default {
    Grade
}